import React from 'react'
// import { useNavigate } from 'react-router-dom';
import Home from '../components/Home'
import Base from './Base'

export default function HomePage() {

    return (
        <Base>
            <Home />
        </Base>
    )
}
